export default __webpack_public_path__ + "static/media/Ballroll_00102.7a5bb06a.png";